import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(3),
  },
  attribute: {
    minWidth: theme.spacing(35),
  },
  confirm: {
    marginLeft: '12px',
    marginTop: theme.spacing(3),
  },
  button: {
    padding: '0.3rem 1rem',
    fontSize: '12px',
    margin: '0 0 0 12px',
    '&:first-child': {
      margin: 0,
    },
  },
  scrollBox: {
    height: `calc(100vh - 64px)`,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
}));

export default useStyles;
